import {
    GET_PRINT_SETUP_LIST_PROGRESS, GET_PRINT_SETUP_LIST_SUCCESS, GET_PRINT_SETUP_LIST_FAILURE,
    ADD_PRINT_SETUP_PROGRESS, ADD_PRINT_SETUP_SUCCESS, ADD_PRINT_SETUP_FAILURE,
    EDIT_DELETE_PRINT_SETUP_PROGRESS, EDIT_DELETE_PRINT_SETUP_SUCCESS, EDIT_DELETE_PRINT_SETUP_FAILURE,

    RESET_MESSAGE,
    WATERMARK_PRINT_SETUP_PROGRESS,
    WATERMARK_PRINT_SETUP_SUCCESS,
    WATERMARK_PRINT_SETUP_FAILURE,
    FOOTER_PRINT_SETUP_PROGRESS,
    FOOTER_PRINT_SETUP_SUCCESS,
    FOOTER_PRINT_SETUP_FAILURE,
    SIGNATURE_PRINT_SETUP_PROGRESS,
    SIGNATURE_PRINT_SETUP_SUCCESS,
    SIGNATURE_PRINT_SETUP_FAILURE,

} from '../../types/actionTypes';

const initialState = {
    printSetup: [],
    watermarkAttachment: "",
    footerAttachment: "",
    signatureAttachment:"",
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const printSetup_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PRINT_SETUP_LIST_SUCCESS:
            return { ...state, printSetup: action.printSetup, loading: false };
        case GET_PRINT_SETUP_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_PRINT_SETUP_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_PRINT_SETUP_PROGRESS:
            return { ...state, loading: true };
        case ADD_PRINT_SETUP_SUCCESS:
            return { ...state, printSetup: [...state.printSetup, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_PRINT_SETUP_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };
        case EDIT_DELETE_PRINT_SETUP_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_PRINT_SETUP_SUCCESS:
            return {
                ...state,
                printSetup: state.printSetup.map((printSetup) =>
                    printSetup.id === action.payload.id ? action.payload : printSetup
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_PRINT_SETUP_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case WATERMARK_PRINT_SETUP_PROGRESS:
            return { ...state, loading: true };
        case WATERMARK_PRINT_SETUP_SUCCESS:
            return { ...state, watermarkAttachment: action.payload.result || "", loading: false, error: false, };
        case WATERMARK_PRINT_SETUP_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case FOOTER_PRINT_SETUP_PROGRESS:
            return { ...state, loading: true };
        case FOOTER_PRINT_SETUP_SUCCESS:
            return { ...state, footerAttachment: action.payload.result || "", loading: false, error: false, };
        case FOOTER_PRINT_SETUP_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case SIGNATURE_PRINT_SETUP_PROGRESS:
            return { ...state, loading: true };
        case SIGNATURE_PRINT_SETUP_SUCCESS:
            return { ...state, signatureAttachment: action.payload.result || "", loading: false, error: false, };
        case SIGNATURE_PRINT_SETUP_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default printSetup_reducer;